import styled from 'styled-components';
import { FONT_SIZE } from '@app/styles/themes/constants';
import { BaseMenu } from '@app/components/common/BaseMenu/BaseMenu';

export const Menu = styled(BaseMenu)`
  background: transparent;
  border-right: 0;
  padding-top: 8px;

  a {
    width: 100%;
    display: block;
  }

  .ant-menu-item,
  .ant-menu-submenu {
    font-size: ${FONT_SIZE.xs};
    margin-top: 2px;
    margin-bottom: 2px;
    border-radius: 8px;
    transition: all 0.3s ease;
  }

  .ant-menu-item {
    padding-left: 12px !important;
    padding-right: 12px !important;
    height: 44px;
    line-height: 44px;
  }

  .ant-menu-submenu-title {
    padding-left: 12px !important;
    padding-right: 12px !important;
    height: 44px;
    line-height: 44px;
  }

  .ant-menu-item-icon {
    width: 1.25rem;
    min-width: 1.25rem;
    margin-right: 9px;
  }

  /* Bỏ khoảng cách mặc định AntD giữa icon và tên (đồng bộ cha + con) */
  .ant-menu-item-icon + span,
  span[role='img'] + span {
    margin-left: 0;
  }

  .ant-menu-submenu-expand-icon,
  .ant-menu-submenu-arrow,
  span[role='img'],
  a,
  .ant-menu-item,
  .ant-menu-submenu {
    color: var(--text-sider-secondary-color);
    fill: var(--text-sider-secondary-color);
  }

  /* Icon mint làm điểm nhấn trên nền teal nhạt */
  .ant-menu-item .ant-menu-item-icon,
  .ant-menu-submenu-title .ant-menu-item-icon,
  .ant-menu-item span[role='img'],
  .ant-menu-submenu-title span[role='img'] {
    color: #a7e8e5;
    fill: #a7e8e5;
  }

  /* Hover: nền sáng nhẹ, chữ trắng, icon mint sáng */
  .ant-menu-item:hover,
  .ant-menu-submenu-title:hover {
    background: rgba(255, 255, 255, 0.08) !important;

    .ant-menu-submenu-expand-icon,
    .ant-menu-submenu-arrow,
    a,
    .ant-menu-title-content {
      color: #ffffff;
      fill: #ffffff;
    }
    .ant-menu-item-icon,
    span[role='img'] {
      color: #a2f0ef;
      fill: #a2f0ef;
    }
  }

  .ant-menu-submenu-selected {
    .ant-menu-submenu-title {
      color: #ffffff;
      background: rgba(255, 255, 255, 0.06);

      .ant-menu-submenu-expand-icon,
      .ant-menu-submenu-arrow,
      span[role='img'] {
        color: #a2f0ef;
        fill: #a2f0ef;
      }
    }
  }

  /* Active: pill trắng mờ nổi trên nền teal (M3 on-dark), chữ + icon trắng */
  .ant-menu-item-selected {
    background: rgba(255, 255, 255, 0.16) !important;

    .ant-menu-submenu-expand-icon,
    .ant-menu-submenu-arrow,
    span[role='img'],
    .ant-menu-item-icon,
    a,
    .ant-menu-title-content {
      color: #ffffff !important;
      fill: #ffffff !important;
    }
  }

  .ant-menu-item-active,
  .ant-menu-submenu-active .ant-menu-submenu-title {
    background: rgba(255, 255, 255, 0.08) !important;
  }

  .ant-menu-sub {
    background: transparent !important;
    margin-top: 2px;
    margin-bottom: 4px;
    border-radius: 8px;

    .ant-menu-item {
      padding-left: 35px !important;
      margin-left: 0 !important;
      margin-right: 0 !important;
      border-radius: 6px;
      height: 35px;
      line-height: 35px;
    }

    /* Icon mục con: nhỏ hơn và sát tên hơn cho gọn */
    .ant-menu-item .ant-menu-item-icon,
    .ant-menu-item span[role='img'] {
      font-size: 0.9rem;
      width: 0.9rem;
      min-width: 0.9rem;
      margin-right: 9px;
    }

    /* Bỏ khoảng cách mặc định AntD giữa icon và tên */
    .ant-menu-item .ant-menu-item-icon + span,
    .ant-menu-item span[role='img'] + span {
      margin-left: 0;
    }

    .ant-menu-item:first-child {
      margin-top: 4px;
    }

    .ant-menu-item:last-child {
      margin-bottom: 4px;
    }
  }
`;
